
<img
    class="newsletter-nugs"
    src="/snackpack/snackpack-submark-nuggets.webp"
    alt="Syntax Snack Pack Logo"
/>


<style lang="postcss">
    /* use mask so that text can match foreground text color (--fg) */
    img {
        width: 100%;
        mask-image: url(/snackpack/snackpack-submark-mask.webp);
        mask-position: 0 0;
        mask-size: 100% 100%;
        background: var(--fg);
        mask-type: alpha;
    }
</style>
